import { HttpModelConverter } from "src/app/modules/core/converter/httpModel.converter";
import { Injectable } from "@angular/core";
import { PrescriptionDefinitionSummaryModel } from "../prescriptionDefinitionSummary.model";
import {PermissionsConverter} from "src/app/modules/common/converter/permissions.converter";

@Injectable({
    providedIn: 'root'
})
export class PrescriptionDefinitionSummaryConverter extends HttpModelConverter<PrescriptionDefinitionSummaryModel> {

    constructor(private permissionConverter: PermissionsConverter) {
        super();
    }

    protected createInstance(): PrescriptionDefinitionSummaryModel {
        return new PrescriptionDefinitionSummaryModel();
    }

    protected enrichObject(result: PrescriptionDefinitionSummaryModel, src: PrescriptionDefinitionSummaryModel) {
        result.permissions = this.permissionConverter.convert(src.permissions);
    }
}